let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h0M7R")).then(() => parcelRequire('8hnH1'));